/** 
* 自动生成文件，请勿修改 
* @name: 财务:现金及现金等价物每年度期初余额
* @description: 现金及现金等价物每年度期初余额==================现金流量表导出使用
* @create: 2024/1/11 下午4:25:21
* @swagger: 2.0
* 合计:6条
*/ 
 
import APIObject from "../utils/APIObject.js" 
const CashBalance = { 
	/** 1 summary:删除-批量	method:post */ 
	batchDelete : new APIObject("/api/CashBalance/batchDelete.do"), 
	/** 2 summary:查询-分页	method:post */ 
	queryPage : new APIObject("/api/CashBalance/queryPage.do"), 
	/** 3 summary:保存/修改-单条	method:post */ 
	saveOrUpd : new APIObject("/api/CashBalance/saveOrUpd.do"), 
	/** 4 summary:查询-单条	method:post */ 
	queryOne : new APIObject("/api/CashBalance/queryOne.do"), 
	/** 5 summary:查询-全部不分页	method:post */ 
	queryAll : new APIObject("/api/CashBalance/queryAll.do"), 
	/** 6 summary:删除-单条	method:post */ 
	delete : new APIObject("/api/CashBalance/delete.do"), 
};
export default CashBalance;